//#region Import
import { useState, useEffect } from "react";
import sharedDatas from "../../businessLogic/sharedDatas";
import { useNavigate, useLocation } from "react-router-dom";

//oneFront SDK
import {
  useSnackbar,  
  useMutation,
  useTranslation,
  useQuery,
} from "@1f/react-sdk";

//Vapor Components
import VaporPage from "@vapor/react-custom/VaporPage";
import Grid from "@vapor/react-material/Grid";
import Box from "@vapor/react-material/Box";
import Button from "@vapor/react-material/Button";
import { ExtendedTabs, ExtendedTab } from "@vapor/react-extended";

//Icons
import { DeleteOutlineOutlined as DeleteIcon } from "@mui/icons-material";

//Custom components
import { Loading } from "../../components/Loading";
import { NotAuth } from "../../components/NotAuth";
import { ModalDelete } from "../../components/ModalDelete";
import { AnagraficheOrfane } from "./AnagraficheOrfane";
import { ModalAnagrafica } from "../../components/ModalAnagrafica";
import { AnagraficheAttive } from "./AnagraficheAttive";
import { AnagrafichePivaErrate } from "./AnagrafichePivaErrate";
import { AnagraficheCfErrati } from "./AnagraficheCfErrati";

//Constants, Api and Data Models
import {
  bsaAnagrafica
} from "../../businessLogic/constants/securityAreas";

import {
  pathAnagraficaHome,
  pathHome
} from "../../businessLogic/constants/path";


import {
  userPermissionModel,
} from "../../businessLogic/models";

import {
  mutation_add_lastActivity_byUserId,
  mutation_delete_lastActivity,
} from "../../businessLogic/mutations/lastActivityMutations";
import { DossierApi } from "../../businessLogic/api/dossierApi";
import { LogApi } from "../../businessLogic/api/logApi";
import { AnagraficaApi } from "../../businessLogic/api/anagraficaApi";
import BaseTableApi from "../../businessLogic/api/baseTableApi";
import { query_base_all } from "../../businessLogic/query/baseTablesQueries";
//#endregion




export const AnagraficaHome = ({ basePath }) => {
  
  //#region Constants
  const tenantId = sharedDatas.getPropertyByName("tenantId");
  const aziendaId = sharedDatas.getPropertyByName("aziendaId");
  const loggedUserId = sharedDatas.getPropertyByName("userId");
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const location = useLocation();
  const dossierApi = DossierApi();
  const anagraficaApi = AnagraficaApi();
  const baseTableApi = BaseTableApi()
  const logApi = LogApi();
  if (
    sharedDatas.getPropertyByName("userId") === "" ||
    sharedDatas.getPropertyByName("tenantId") === ""
  ) {
    navigate(pathHome);
  }
  //#endregion

  //#region Query
  const apiBaseAll = useQuery(
    query_base_all,
    {},
    { lazy:true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
  )

  //#region Mutation
  const apiAddLastActivity = useMutation(mutation_add_lastActivity_byUserId, {
    graphqlEndpoint: "aml:hasura:api://v1/graphql",
  });
  const apiDeleteLastActivity = useMutation(mutation_delete_lastActivity, {
    graphqlEndpoint: "aml:hasura:api://v1/graphql",
  });
  //#endregion

  //#region UseStates
  const [backDropOpen, setBackDropOpen] = useState(true); //Loader utilizzato durante il caricamento
  const [isDataLoaded, setIsDataLoaded] = useState(false); //Indica lo stato di caricamento del result Api
  const [hasTreeDataError, setHasTreeDataError] = useState(false); //Indica se ci sono errori nei path duplicati
  const [userPermissions, setUserPermissions] = useState(
    new userPermissionModel(
      0,
      aziendaId,
      bsaAnagrafica,
      false,
      false,
      false,
      false
    )
  ); //Contiene i permessi utente
  const [baseProvince,setBaseProvince] = useState([]); //Contiene le province base
  const [baseComuni,setBaseComuni] = useState([]); //Contiene i comuni base
  //DataGrid
  const [activeRows, setActiveRows] = useState([]); //Contiene le rows delle anagrafiche attive  
  const [inactiveRows, setInactiveRows] = useState([]); //Contiene le rows delle anagrafiche inattive(orfane)
  const [wrongRows, setWrongRows] = useState([]); //Contiene le rows delle anagrafiche con P.IVA errata
  const [wrongCfRows, setWrongCfRows] = useState([]); //Contiene le rows delle anagrafiche con Codice Fiscale errato
  //Tabs
  const [selectedTab, setSelectedTab] = useState("tabAnagrafiche");
  //Selection
  const [selectedOrfaneRows, setSelectedOrfaneRows] = useState([]);
  //Modal
  const [showModalAnagrafica, setShowModalAnagrafica] = useState(false);
  const [selectedAnagraficaOrfana, setSelectedAnagraficaOrfana] = useState(null);
  const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
  //#endregion

  useEffect(() => {
    loadDatas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDataLoaded]);

  useEffect(() => {
    // Intercetta il parametro activeTab dalla navigazione
    if (location.state?.activeTab) {
      setSelectedTab(location.state.activeTab);
      // Pulisci lo state dopo averlo utilizzato
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  //#region Methods
  async function loadDatas() {
    try {
      if (
        sharedDatas.getPropertyByName("tenantId") === "" ||
        sharedDatas.getPropertyByName("tenantModel") === null ||
        sharedDatas.getPropertyByName("aziendaId") === 0 ||
        sharedDatas.getPropertyByName("aziendaModelList") === null ||
        sharedDatas.getPropertyByName("userId") === "" ||
        sharedDatas.getPropertyByName("userModel") === null
      ) {
        navigate("/");
      } else {
        setBackDropOpen(true);
        if (!isDataLoaded && loggedUserId !== "" && tenantId !== "") {
          //Last Activity
          await apiDeleteLastActivity.fetch({
            tenantId: tenantId,
            aziendaId: aziendaId,
            userId: loggedUserId,
          });
          await apiAddLastActivity.fetch({
            tenantId: tenantId,
            aziendaId: aziendaId,
            path: pathAnagraficaHome,
            entityId: "",
            entityName: "",
          });

          /**************************************/
          //Carico i permessi relativi all'utente
          const userPerms = sharedDatas
            .getPropertyByName("userPermissions")
            .filter((x) => x.area === bsaAnagrafica)[0];
          setUserPermissions(userPerms);          

          //Recupero le province
          let apiBaseAllResponse = await apiBaseAll.fetch({
            tenantId: tenantId,
          });
          let baseProvinceArr = baseTableApi.GetBaseProvincia(apiBaseAllResponse);
          setBaseProvince(baseProvinceArr);
          let baseComuniArr = baseTableApi.GetBaseComune(apiBaseAllResponse);
          setBaseComuni(baseComuniArr);
          /**************************************/
          //Carico le anagrafiche                           
          let allFascicoliByAzienda = await dossierApi.getDossiers();
          let activeRows = allFascicoliByAzienda.filter(dossier => dossier.aziendaId === aziendaId);          
          
          // Verifica duplicati nei path prima di impostare le righe
          const pathMap = new Map();
          let hasDuplicates = false;
          
          for (const row of activeRows) {
            if (row.path && row.path.length > 0) {
              const pathKey = JSON.stringify(row.path);
              if (pathMap.has(pathKey)) {
                hasDuplicates = true;
                console.error("Path duplicato trovato:", row.path, "IDs:", pathMap.get(pathKey), row.pathId);
              } else {
                pathMap.set(pathKey, row.pathId);
              }
            }
          }
          
          if (hasDuplicates) {
            setHasTreeDataError(true);
          }
          
          setActiveRows(activeRows.sort((a, b) => (a.path?.[0] || "").localeCompare(b.path?.[0] || "")));          

          let malformedPIvaRows = allFascicoliByAzienda.filter(dossier => dossier.isPivaWrong && dossier.aziendaId === aziendaId);
          setWrongRows(malformedPIvaRows.sort((a, b) => (a.path?.[0] || "").localeCompare(b.path?.[0] || "")));          

          let malformedCfRows = allFascicoliByAzienda.filter(dossier => dossier.isCfWrong && dossier.aziendaId === aziendaId);
          setWrongCfRows(malformedCfRows.sort((a, b) => (a.path?.[0] || "").localeCompare(b.path?.[0] || "")));

          let anagOrfane = await anagraficaApi.GetAnagraficheOrfane()
          setInactiveRows(anagOrfane);
        }
      } 
    } catch (e) {
      logApi.AddLog(e.message, e.stack, "loadDatas","AnagraficaHome");      
      enqueueSnackbar(t("error.generale"), { variant: "error" });
    } finally {
      setBackDropOpen(false);
      setIsDataLoaded(true);
    }
  }
  //#endregion
  
  //#region Handler
  const handleChangeTab = (event, newValue) => {
    setSelectedTab(newValue);
  };
  
  const handleAnagraficaOrfanaDetailClick = (anagrafica) => {
    setSelectedAnagraficaOrfana(anagrafica);
    setShowModalAnagrafica(true);
  };
  
  const handleCloseModalAnagrafica = () => {
    setShowModalAnagrafica(false);
    setSelectedAnagraficaOrfana(null);
  };

  const handleDeleteAnagraficaOrfana = async (anagraficaId) => {
    try {
      setBackDropOpen(true);
      const result = await anagraficaApi.DeleteAnagrafica(anagraficaId);
      if (result) {
        enqueueSnackbar("Anagrafica eliminata con successo", { variant: "success" });
        // Ricarica i dati
        setIsDataLoaded(false);
      }
    } catch (error) {
      logApi.AddLog(error.message, error.stack, "handleDeleteAnagraficaOrfana", "AnagraficaHome");
      enqueueSnackbar(error.message || t("error.generale"), { variant: "error" });
    } finally {
      setBackDropOpen(false);
    }
  };

  const handleBulkDeleteAnagraficheOrfane = async (anagraficaIds) => {
    try {
      setBackDropOpen(true);
      for (const id of anagraficaIds) {
        await anagraficaApi.DeleteAnagrafica(id);
      }
      enqueueSnackbar(`${anagraficaIds.length} anagrafiche eliminate con successo`, { variant: "success" });
      setSelectedOrfaneRows([]);
      setIsDataLoaded(false);
    } catch (error) {
      logApi.AddLog(error.message, error.stack, "handleBulkDeleteAnagraficheOrfane", "AnagraficaHome");
      enqueueSnackbar(error.message || t("error.generale"), { variant: "error" });
    } finally {
      setBackDropOpen(false);
    }
  };

  const handleCloseBulkDeleteModal = () => {
    setShowBulkDeleteModal(false);
  };

  const handleConfirmBulkDelete = async () => {
    await handleBulkDeleteAnagraficheOrfane(selectedOrfaneRows);
    setShowBulkDeleteModal(false);
  };
  //#endregion

  //#region Return Graphics
  return (
    <VaporPage title={t("nav.anagrafiche")}>
      <Loading open={backDropOpen} />
      
      <ModalAnagrafica
        show={showModalAnagrafica}
        onClose={handleCloseModalAnagrafica}
        anagrafica={selectedAnagraficaOrfana}
        allProvince={baseProvince}
        allComuni={baseComuni}
      />

      <ModalDelete
        show={showBulkDeleteModal}
        strongDelete={true}
        confirmString="conferma"
        deleteMessage={`Attenzione si stanno eliminando ${selectedOrfaneRows.length} anagrafiche: questa azione è irreversibile.`}
        onClose={handleCloseBulkDeleteModal}
        onOk={handleConfirmBulkDelete}
      />

      {isDataLoaded && !userPermissions.canRead ? <NotAuth /> : null}

      {isDataLoaded && userPermissions.canRead ? (
        <VaporPage.Section>
          <Box sx={{ position: "relative", mb: 2 }}>
            <ExtendedTabs
              variant="standard"
              size="small"
              value={selectedTab}
              onChange={handleChangeTab}
            >
              <ExtendedTab
                value="tabAnagrafiche"
                label="Utilizzate"
              />
              <ExtendedTab
                value="tabOrfane"
                label="Inutilizzate"
              />            
              {wrongRows && wrongRows.length > 0 &&
                <ExtendedTab
                  value="tabErrate"
                  label="P.Iva Errate"
                  color="red"
                />
              }
              {wrongCfRows && wrongCfRows.length > 0 &&
                <ExtendedTab
                  value="tabCfErrate"
                  label="Cod. Fisc. Errati"
                  color="red"
                />
              }
            </ExtendedTabs>
            {selectedTab === "tabOrfane" && userPermissions.canDelete && selectedOrfaneRows.length > 0 && (
              <Button
                variant="contained"
                color="error"
                size="small"
                startIcon={<DeleteIcon />}
                onClick={() => setShowBulkDeleteModal(true)}
                sx={{ position: "absolute", right: 0, top: "50%", transform: "translateY(-50%)" }}
              >
                Elimina selezionate ({selectedOrfaneRows.length})
              </Button>
            )}
          </Box>

          {selectedTab === "tabAnagrafiche" && (
            <AnagraficheAttive 
              activeRows={activeRows}
              hasTreeDataError={hasTreeDataError}
            />
          )}

          {selectedTab === "tabOrfane" &&
            <Grid container>
              <Grid item xs={12} sx={{ width: "100%" }}>
                <AnagraficheOrfane
                  anagrafiche={inactiveRows}                  
                  onDetailClick={handleAnagraficaOrfanaDetailClick}
                  onDeleteAnagrafica={handleDeleteAnagraficaOrfana}
                  onBulkDeleteAnagrafiche={handleBulkDeleteAnagraficheOrfane}
                  permissions={userPermissions}
                  selectedRows={selectedOrfaneRows}
                  onSelectionChange={setSelectedOrfaneRows}
                />
              </Grid>
            </Grid>
          }

          {wrongRows && wrongRows.length > 0 && selectedTab === "tabErrate" && (
            <AnagrafichePivaErrate wrongRows={wrongRows} />
          )}           
          

          {wrongCfRows && wrongCfRows.length > 0 && selectedTab === "tabCfErrate" && (
            <AnagraficheCfErrati wrongCfRows={wrongCfRows} />
          )}
        </VaporPage.Section>
      ) : null}
    </VaporPage>
  );
  //#endregion
};









